import { render, staticRenderFns } from "./PurchaseDocuments.vue?vue&type=template&id=cfd34888"
import script from "./PurchaseDocuments.vue?vue&type=script&lang=js"
export * from "./PurchaseDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports